(function () {
    'use strict';

    const base = 'https://licenses.nandakusumadi.com/v1/muxsmith/';
    const storageKey = 'muxsmith-supporter-checkout';
    const paddleSource = 'https://cdn.paddle.com/paddle/v2/paddle.js';
    const paddleConfig = document.querySelector('[data-muxsmith-paddle-config]');
    const clientToken = paddleConfig ? paddleConfig.dataset.clientToken.trim() : '';
    const successUrl = paddleConfig ? paddleConfig.dataset.successUrl : '';
    let paddlePromise;
    let paddleInitializationPromise;

    function loadPaddle() {
        if (window.Paddle) return Promise.resolve(window.Paddle);
        if (!paddlePromise) {
            paddlePromise = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = paddleSource;
                script.onload = () => resolve(window.Paddle);
                script.onerror = () => reject(new Error('paddle_unavailable'));
                document.head.appendChild(script);
            });
        }
        return paddlePromise;
    }

    async function initializePaddle() {
        if (!paddleInitializationPromise) {
            paddleInitializationPromise = loadPaddle().then(Paddle => {
                if (!Paddle || !clientToken) throw new Error('paddle_unavailable');
                Paddle.Initialize({
                    token: clientToken,
                    checkout: {settings: {displayMode: 'overlay', theme: 'light', successUrl}}
                });
                return Paddle;
            });
        }
        return paddleInitializationPromise;
    }

    async function post(path, body) {
        const response = await fetch(base + path, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(body)
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.error || 'request_failed');
        return result;
    }

    const checkout = document.querySelector('[data-muxsmith-checkout]');
    if (checkout && clientToken) {
        checkout.disabled = false;
        checkout.textContent = 'Buy Supporter — $9.99';
        checkout.addEventListener('click', async () => {
            const status = document.querySelector('[data-muxsmith-checkout-status]');
            checkout.disabled = true;
            status.textContent = 'Opening Paddle checkout…';
            try {
                const result = await post('checkout', {});
                sessionStorage.setItem(storageKey, JSON.stringify({transactionId: result.transactionId, claimToken: result.claimToken}));
                const Paddle = await initializePaddle();
                Paddle.Checkout.open({transactionId: result.transactionId});
                status.textContent = 'Paddle checkout is open.';
            } catch {
                status.textContent = 'Checkout could not be opened. Muxsmith remains available to use for free.';
                checkout.disabled = false;
            }
        });
    } else if (checkout) {
        checkout.textContent = 'Supporter checkout is not available';
        const status = document.querySelector('[data-muxsmith-checkout-status]');
        status.textContent = 'Muxsmith remains available to use for free.';
    }

    if (clientToken && new URLSearchParams(window.location.search).has('_ptxn')) {
        initializePaddle().catch(() => {
            const status = document.querySelector('[data-muxsmith-checkout-status]');
            if (status) status.textContent = 'Checkout could not be opened. Try again from the button on this page.';
        });
    }

    const resultSection = document.querySelector('[data-muxsmith-purchase-result]');
    if (resultSection && new URLSearchParams(window.location.search).has('complete')) {
        resultSection.hidden = false;
        const message = resultSection.querySelector('[data-muxsmith-purchase-message]');
        const output = resultSection.querySelector('[data-muxsmith-license-key]');
        const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (!saved) {
            message.textContent = 'Use licence recovery below if your key does not appear.';
        } else {
            let attempts = 0;
            const recover = async () => {
                attempts += 1;
                try {
                    const response = await post('licenses/recover', saved);
                    output.textContent = response.licenseKey;
                    message.textContent = 'Save this key in a password manager. You can also recover it by email.';
                    sessionStorage.removeItem(storageKey);
                } catch (error) {
                    if (error.message === 'fulfillment_pending' && attempts < 10) return window.setTimeout(recover, 1500);
                    message.textContent = 'The licence is not ready yet. Use recovery below or contact support.';
                }
            };
            recover();
        }
    }

}());
